module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "chap-title",
    attrs: {
      "id": "ch4"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/com-a.jpg"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Last Slaver: Voyage of the Clotilda")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-author"
  }, [_vm._v("by Sheritta Bitikofer")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Originally posted as a two-part blog at Emerging Civil War January 28-29, 2022")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On December 1, 1806, the 9th U.S. Congress passed an act to “prohibit the importation of slaves, into any port or place within the jurisdiction of the United States.” From January 1, 1808, it would be unlawful “to hold, sell, or dispose of such [imported] negro, mulatto, or person of color, as a slave, or to be held to service or labor.” Additionally, it would be illegal for an American citizen to build or outfit a ship for the purpose or to assist in carrying out the crime—including as ship’s crew or captain. Violators risked prosecution, imprisonment for 5 to 10 years, or fines from $5,000 to $20,000 depending on their involvement."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn1",
      "id": "rch4fn1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the act did not stop the international slave trade. Neither did it slow the domestic trade, which became the largest source of income in the South second to the plantation system, and forced 1.2 million enslaved men, women, and children between 1790 and the 1860s to travel hundreds "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("of miles to new plantations in the south and west."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn2",
      "id": "rch4fn2"
    }
  }, [_vm._v("2")])]), _vm._v(" The African American newspaper, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Freedom’s Journal")]), _vm._v(", lamented: “We may declaim as much as we please upon the horrors of the foreign slave trade, but we would ask, are the horrors of the internal trade less—are the relations of life less endearing in this country than in Africa—are the Wood folks of the South less cruel than the slavers on the coast?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn3",
      "id": "rch4fn3"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "fig2",
      "src": "images/f0018-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("V"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OYAGE OF")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LOTILDA")])]), _vm._v(", T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AST")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LAVER")]), _vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clotilda")]), _vm._v(" was the last slaver on the “middle passage,” an in-between time for human cargo. Their forced march from inland homes to coastal ports of sale, usually by other Africans, was the first passage. The final passage proceeded from the American port of disembarkation to the location of enslavement.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Outlawing international trade along with the surging domestic trade raised the price of the enslaved. In Richmond, Virginia, in 1860, a prime male fetched between $1,550 and $1,620, while enslavers as far south as Mobile could expect costs of $2,400 for the same."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn4",
      "id": "rch4fn4"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("Enslavers would risk the illegal trip to Africa, purchase captives, and return to hand over their human cargo to custom house officers as “informers” of the crime in return for a reward, while the Africans would be sold at auction for state revenue. As one violator admitted: “The law gave the informer half the value of the Negroes, which were put up and sold in the United States.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn5",
      "id": "rch4fn5"
    }
  }, [_vm._v("5")])]), _vm._v(" Other slavers would sell smuggled Africans to planters who agreed to their purchases beforehand. Ships like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Wanderer")]), _vm._v(", which had landed over 400 captives on Jekyll Island, Georgia, on November 28, 1858, gained public notoriety."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn6",
      "id": "rch4fn6"
    }
  }, [_vm._v("6")])]), _vm._v(" However, enslavers were often not brought to justice while Africans were sold across the South. One planter and businessman in Mobile was determined to do the same.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Timothy Meaher was second generation Irish, born in Whitefield, Maine in 1817. In the 1830s, he traveled to Mobile to enter the shipbuilding business. By 1860, he and his brothers, James and Burns, owned cotton plantations and lumber mills, and made a profitable business in building and operating steamboats carrying goods and passengers from Montgomery to Mobile. He, like many planters, believed the international slave trade should be reinstated so the price of labor would decrease. Many large planters, however, opposed reinstatement of the trade because it would upset the class balance between slaveholders and non-slaveholders, devalue enslaved property, and reduce their fortunes. In Mobile, where 13 million bales of cotton were exported between 1817 and 1861, and a quarter of its 30,000 citizens were enslaved by 1860, any threat to the institution was distressing."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn7",
      "id": "rch4fn7"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One night on the steamboat "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Roger B. Taney")]), _vm._v(" between Montgomery and Mobile, Timothy Meaher and a few guests were discussing the latest attempt by Congress to suppress the slave trade and hotly debating the risks of smuggling. According to one account, Timothy bet “a thousand dollars that inside two years I myself can bring a shipful of n—s into Mobile Bay under the officers’ noses.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn8",
      "id": "rch4fn8"
    }
  }, [_vm._v("8")])]), _vm._v(" He would make good on his bet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("The ideal choice of ship captain was William Foster, a thirty-seven-year-old native of Nova Scotia who came to Mobile in 1843 to build ships. As an accomplished seafarer and close friend to Meaher, Foster was hired for the job of piloting the ship to Africa. Recruiting a crew would prove more difficult. Sailors, regardless of their opinions on the slave trade, often did not want to have any part in the crime. If the ship were caught in the ocean, they could be stranded in Africa or on a nearby island without means to return home. Therefore, the crew of eleven hired by Foster were not told about the mission.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meaher’s ship of choice was the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clotilda")]), _vm._v(", a fast schooner that Foster had built in 1855 and Meaher purchased for $35,000. A Mobile newspaper boasted: “This vessel in model and fastning does great credit to her builder, and affords another evidence of the capacity of our city for successful and economical shipbuilding.” At 120 tons, 86 feet long, 23 feet wide, with two masts and one deck, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clotilda")]), _vm._v(" could carry 190 captives. Modifications were needed to prepare her for the Atlantic Ocean, making her into a “low craft with tall masts, long spars, and broad sails like the wings of a yachting racer.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn9",
      "id": "rch4fn9"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("American, British, and Portuguese navies patrolled the African coast to seize smugglers but achieved only intermittent success. The vigilant Royal Navy had captured 1,600 slavers since 1807."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn10",
      "id": "rch4fn10"
    }
  }, [_vm._v("10")])]), _vm._v(" Great Britain outlawed the slave trade nearly a year before 1808 and abolished slavery completely in most colonies by 1833. Portugal ended it at home in 1761 while preserving the institution in Brazil where Africans continued to be trafficked. Slavers caught in the Atlantic would be seized, the crew arrested, and the Africans taken to Sierra Leone or Liberia—designated colonies for such purposes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Patrol ships were not the only worry as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clotilda")]), _vm._v(" set sail on March 3, 1860, from Mobile. On March 17, they encountered a violent storm while evading a Portuguese man-of-war in a ten-hour pursuit. On April 14, they sighted the Cape Verde Islands off the coast of Africa and intended to make repairs, only to spot another Portuguese vessel. Foster changed course, “to "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _vm._v("get away from her not wishing to be boarded so early on the voyage.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn11",
      "id": "rch4fn11"
    }
  }, [_vm._v("11")])]), _vm._v(" They escaped again and pulled into Praia for repairs, where the crew finally discovered the mission. The sailors threatened to mutiny and, to quiet their fears, Foster promised double pay upon return to Mobile. After two and a half months at sea, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clotilda")]), _vm._v(" arrived in the African port of Ouidah in the Bight of Benin on May 15, 1860.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Africans held at the Ouidah barracoons (holding cells for captives slated for sale) came from all walks of life and different tribes. Most were from the Yoruba, though many were of the Hausa, Fon, and Nupe tribes. Tribes held similar customs and traditions, such as scarification (the practice of scarring one’s face and body for cultural purposes), tattoos, and teeth filing to denote status. Men and women worked as merchants, traders, farmers, craftsmen, fishermen, priests or priestesses, doctors, or skilled artisans. Teens were initiated into secret societies to signal their coming into adulthood and marriage eligibility.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most tribes practiced polytheistic or animistic faiths, or were Muslim. They also practiced slavery. Export of Africans became so ingrained in their economy that even international prohibition could not inhibit trafficking of black bodies. Slavery within African society was not based on race, but social status, and was considered a temporary condition that did not hinder social mobility after a term of enslavement. While enslaved, Africans served in a variety of capacities, based on skillset, and enjoyed limited freedoms including owning property and living separately from their owners.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These societies were complex, cultures rich with tradition, communities close, and economies diverse, while connections of family were—and still are—pivotal. By European standards, however, Africans lived as “savages.” This paternalistic view rationalized the institution as favoring the Africans by civilizing them."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn12",
      "id": "rch4fn12"
    }
  }, [_vm._v("12")])]), _vm._v(" Many captives were kidnapped by the Dahomey kingdom or were prisoners of tribal conflicts plaguing the area. Some had been taken by desperate individuals seeking to exchange them for "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("captured loved ones."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn13",
      "id": "rch4fn13"
    }
  }, [_vm._v("13")])]), _vm._v(" Many within the barracoons with distinct languages had difficulty communicating, though some traders were multi-lingual and became translators. Temporary friendships formed amongst strangers as captives struggled to cope.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Foster hand-selected and purchased 125 Africans for $9,000 in gold and goods, ranging in age from 15 to 30, and as varied as African society itself. Their names—Gumpa, Zuma, Kanko, Osso, Jabba, Kupollee, Kossola, and Abile—told stories in their respective languages. For example, Kossola meant “my children do not die any more,” suggesting that his parents lost children before him."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn14",
      "id": "rch4fn14"
    }
  }, [_vm._v("14")])]), _vm._v(" Other names denoted the child’s birth season or day of the week. Soon, these names would be their only remaining connection to Africa. To minimize vermin, their colorful clothes were stripped away and all hair shaved as they were prepared for sale.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On May 24, 1860, ten days after arrival, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clotilda")]), _vm._v(" was almost ready to depart when another Portuguese ship on the horizon spooked Foster. He hastened loading but left 15 Africans on the beach."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn15",
      "id": "rch4fn15"
    }
  }, [_vm._v("15")])]), _vm._v(" The Atlantic crossing or “middle passage” placed the remaining 110 naked Africans in a world of uncertainty and hardship—a crowded and cramped hold 20 feet wide and 5 feet high. They probably were seasick and/or injured from the rolling and colliding of bodies. Wounds and open sores from rubbing rough wooden planks or chafing chains caused great discomfort.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Luckily, none became seriously ill—despite sitting in their own filth during the voyage—because Foster did not have a physician onboard. They were brought on deck after thirteen days, taking their first breath of fresh air since leaving Africa. Many had to be carried on deck too weak to stand or walk. For the rest of the trip, the Africans spent more time on deck and were observant of the crew and surroundings. The most common complaint was lack of water. Despite historical mortality rates reaching 16% in the 1850s, no African on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clotilda")]), _vm._v(" perished during the voyage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The journey to Mobile took 45 days. Entering the Gulf of Mexico, the captives remembered seeing the water change color. Before "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clotilda")]), _vm._v(" sailed "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("into Mobile Bay, the crew mutinied again. Once more, Foster promised more money. On July 8, one of Meaher’s steamboats tugged the ship up the Spanish River toward Twelve Mile Island, where the Africans were transferred to a steamboat that would take them up the Tombigbee River under cover of night. From there, they were brought to the confluence of the Tombigbee and Alabama Rivers near Burns, Meaher’s plantation, where they would be parceled out to the buyers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Meaher planned to repair and clean "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clotilda")]), _vm._v(" to resume life as an ordinary cargo vessel, but evidence left behind in the cargo hold could not be erased. Foster took his ship upriver to Bayou Canot, twelve miles northwest of Twelve Mile Island, and set it ablaze. She was not destroyed completely and, during low tide, remains were visible for decades. Meaher took the crew, ready to receive their promised pay, onto the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Roger B. Taney")]), _vm._v(". He distributed alcohol and stashed them in a secluded part of the ship so they couldn’t interact with paying passengers en route to Montgomery. Upon arrival, and to prevent the crew from spilling the beans, Meaher transferred them to a mail-train headed North with only $600-$700 each, their original promised pay."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn16",
      "id": "rch4fn16"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("News of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clotilda")]), _vm._v(" voyage spread anyway, showing up in newspapers from New York to New Orleans, some exaggerating the details. Legal action followed. Timothy Meaher and William Foster were tried and acquitted of charges for import tax evasion and smuggling Africans. There was no evidence and there were no witnesses other than the Africans, whom officials could not find. Ironically, when the constitution of the Confederacy was drafted on March 11, 1861, Article I, Section IX stated, “The importation of negroes of the African race from any foreign country other than the slaveholding States or territories of the United States of America, is hereby forbidden.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#ch4fn17",
      "id": "rch4fn17"
    }
  }, [_vm._v("17")])]), _vm._v(" Meaher’s actions would also have been considered illegal by the Confederacy. He subsequently assisted the "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("Confederacy in blockade running along the Gulf Coast, sacrificing a few of his ships in the process.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Africans were enslaved to planters in Alabama, experiencing one tragic separation after another until freedom in 1865. They learned English and adjusted to American customs, while enduring racism during Reconstruction and Jim Crow. Hopes of returning to homes in Africa never would be fulfilled. Instead, they made a new home just outside of Mobile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A group of Africans in the Mobile area purchased land beginning in 1870 and founded the community of Africatown. Since then, descendants of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clotilda")]), _vm._v(" Africans have kept their heritage and history alive despite encroaching industrial development. The Clotilda Descendants Association, founded in 1984, pioneered public education about "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clotilda")]), _vm._v(" and Africatown. A heritage center, complete with a museum, is currently in construction to be completed in 2022. Journalist Ben Rains discovered the remains of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clotilda")]), _vm._v(" in 2018 near Twelve Mile Island. According to specialists, it might be possible to salvage DNA from the wreck. Since its discovery, nautical archeologists produced a sonar image of the hull, revealing evidence courts lacked in 1860.")]), _vm._v(" "), _c('div', {
    staticClass: "image_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/f0024-01.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Cudjo Lewis, also called Kossola (c. 1841-July 17, 1935), was a Yoruba African survivor of the voyage. Shortly after emancipation, he requested free lands from Timothy Meaher for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clotilda")]), _vm._v(" Africans to build a community. When denied, they purchased the land through community funding. Lewis married another survivor, Abile (also called Celia), and had six children who each received an African and American name. He worked at a lumber mill and as a general laborer until an accident in 1902. He was sexton of the church (now Union Missionary Baptist Church in Africatown). Lewis was one of the last "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Clotilda")]), _vm._v(" survivors residing in Africatown. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Wikimedia Commons Public Domain")])])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn1",
      "id": "ch4fn1"
    }
  }, [_vm._v("1")]), _vm._v(" “An Act of March 2, 1807, 9th Congress, 2nd Session, 2 STAT 426, to Prohibit the Importation of Slaves” ("), _c('a', {
    attrs: {
      "href": "https://www.docsteach.org/documents/document/act-prohibit-importation-slaves",
      "target": "_blank"
    }
  }, [_vm._v("https://www.docsteach.org/documents/document/act-prohibit-importation-slaves")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn2",
      "id": "ch4fn2"
    }
  }, [_vm._v("2")]), _vm._v(" Alfred H. Conrad and John R. Meyer, “The Economics of Slavery in the Antebellum South,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Journal of Political Economy")]), _vm._v(", Volume LXVI, No. 2, April 1958, 112.")]), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn3",
      "id": "ch4fn3"
    }
  }, [_vm._v("3")]), _vm._v(" “Domestic Slave Trade,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Freedom’s Journal")]), _vm._v(", New York, October 17, 1828.")]), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn4",
      "id": "ch4fn4"
    }
  }, [_vm._v("4")]), _vm._v(" Price list of Betts & Gregory of Richmond, D.M. Pulliam Papers, Perkins Library, Duke University; Albert Burton Moore, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("History of Alabama")]), _vm._v(" (Alabama University, University Supply Store, 1934), 355.")]), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn5",
      "id": "ch4fn5"
    }
  }, [_vm._v("5")]), _vm._v(" Dr. Kilpatrick, “Early Life in the Southwest: The Bowies,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("De Boy’s Review")]), _vm._v(" 13, 4 October 1852, 378-83.")]), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn6",
      "id": "ch4fn6"
    }
  }, [_vm._v("6")]), _vm._v(" Sylviane A. Diouf, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dreams of Africa in Alabama: The Slave Ship")]), _vm._v(" Clotilda "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and the Story of the Last Africans Brought to America")]), _vm._v(" (Oxford, 2007), 21.")]), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn7",
      "id": "ch4fn7"
    }
  }, [_vm._v("7")]), _vm._v(" Diouf, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dreams of Africa")]), _vm._v(", 7, 11, 18-19.")]), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn8",
      "id": "ch4fn8"
    }
  }, [_vm._v("8")]), _vm._v(" Ibid., 21.")]), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn9",
      "id": "ch4fn9"
    }
  }, [_vm._v("9")]), _vm._v(" “Last Cargo of Slaves,” Saint Louis "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Globe Democrat")]), _vm._v(", November 30, 1890; Untitled Newspaper Clipping, October 17, 1855, USA Archives, Mobile; Samuel Hawkins Marshall Byers, “The Last Slave Ship,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Harper’s Monthly")]), _vm._v(" 113, 1906, 744.")]), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn10",
      "id": "ch4fn10"
    }
  }, [_vm._v("10")]), _vm._v(" Warren S. Howard, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("American Slavers and the Federal Law, 1837-1862")]), _vm._v(" (Berkeley, 1963), 18.")]), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn11",
      "id": "ch4fn11"
    }
  }, [_vm._v("11")]), _vm._v(" Diouf, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dreams of Africa")]), _vm._v(", 27; William Foster, “Last Slaver from U.S. to Africa. A.D. 1860,” Mobile Public Library, Local History and Genealogy, 3.")]), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn12",
      "id": "ch4fn12"
    }
  }, [_vm._v("12")]), _vm._v(" Daniel Walker Howe, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("What God Hath Wrought: The Transformation of America, 1815-1848")]), _vm._v(" (New York, 2007), 58.")]), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn13",
      "id": "ch4fn13"
    }
  }, [_vm._v("13")]), _vm._v(" Slyviane A. Diouf, “The Last Resort: Redeeming Relatives and Friends,” in Diouf ed., "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Fighting the Slave Trade:")]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("West African Strategies")]), _vm._v(" (Athens, OH, 2003), 81-100.")]), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn14",
      "id": "ch4fn14"
    }
  }, [_vm._v("14")]), _vm._v(" Herbert S. Klein, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Atlantic Slave Trade")]), _vm._v(", (Cambridge, 1999), 199.")]), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn15",
      "id": "ch4fn15"
    }
  }, [_vm._v("15")]), _vm._v(" Emma Langdon Roche, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Historic Sketches of the South")]), _vm._v(" (New York, 1914), 99.")]), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn16",
      "id": "ch4fn16"
    }
  }, [_vm._v("16")]), _vm._v(" William Foster, “Last Slaver from U.S. to Africa. A.D. 1860,” Mobile Public Library, Local History and Genealogy, 12; “Last Cargo of Slaves” Saint Louis "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Globe Democrat")]), _vm._v(", November 30, 1890; Roche, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Historical Sketches")]), _vm._v(", 85, 97; Henry Romelyn, “Little Africa,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Southern Workman")]), _vm._v(" 26, I, January 1897, 15; Samuel Hawkins Marshall Byers, “The Last Slave Ship,” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Harper’s Monthly")]), _vm._v(" 113, 1906, 746.")]), _vm._v(" "), _c('p', {
    staticClass: "num_listp"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/13_Chapter04#rch4fn17",
      "id": "ch4fn17"
    }
  }, [_vm._v("17")]), _vm._v(" James D. Richardson, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Compilation of the Messages and Papers of the Confederacy, Including the Diplomatic Correspondence 1861-1865")]), _vm._v(" (Nashville, 1905).")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-724b2895","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/13_Chapter04.vue
// module id = 96
// module chunks = 0